interface IStatusIndicatorProps {
    status: 'success' | 'error';
    statusText: string;
}

export function StatusIndicatorDot(props: IStatusIndicatorProps) {
    if (props.status === 'success') {
        return (
            <span title={props.statusText} className="text-(--mantine-color-success-4)">
                &bull;
            </span>
        );
    } else {
        return (
            <span title={props.statusText} className="text-(--mantine-color-error-4)">
                &bull;
            </span>
        );
    }
}
